export default {
  'Resolution': 'الدقة',
  'Frame rate': 'معدل الإطار',
  'The higher the frame rate, the smoother the animation': 'كلما زاد معدل الإطارات ، كانت الرسوم المتحركة أكثر سلاسة.',
}